/* MagMount theme scripts (no dependencies) */
(function () {
  'use strict';
  var cfg = window.hzConfig || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money (uses the shop's own format so every currency renders correctly) ---------- */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function fmt(n, dec, thou, decSep) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return s.join(dec ? decSep : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, isErr) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'hz-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-err', !!isErr);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* ---------- header height + scroll shadow ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    function measure() { document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px'); }
    measure();
    window.addEventListener('resize', measure);
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- announcement rotator ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach(function (bar) {
      var msgs = $$('.hz-ann__msg', bar);
      if (msgs.length < 2) return;
      var i = 0, ms = parseInt(bar.getAttribute('data-interval'), 10) || 3000;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- generic overlay (menu drawer + cart drawer) ---------- */
  var openOverlay = null;
  function open(el, opener) {
    if (!el) return;
    if (openOverlay && openOverlay !== el) close(openOverlay);
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hz-locked');
    openOverlay = el; el._opener = opener || null;
    var f = el.querySelector('button, a, [tabindex]'); if (f) setTimeout(function () { f.focus(); }, 50);
    $$('[data-drawer-open]').forEach(function (b) { if (el.hasAttribute('data-drawer')) b.setAttribute('aria-expanded', 'true'); });
  }
  function close(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hz-locked');
    if (openOverlay === el) openOverlay = null;
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (el._opener) el._opener.focus();
  }

  function initDrawers() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var openBtn = t.closest('[data-drawer-open]');
      if (openBtn) { e.preventDefault(); open($('[data-drawer]'), openBtn); return; }
      var closeBtn = t.closest('[data-drawer-close]');
      if (closeBtn) { close($('[data-drawer]')); return; }
      var cartOpen = t.closest('[data-cart-open]');
      if (cartOpen && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
        e.preventDefault(); open($('[data-cart-drawer]'), cartOpen); return;
      }
      if (t.closest('[data-cart-close]')) { close($('[data-cart-drawer]')); return; }
      // close an open <details> dropdown when clicking elsewhere
      $$('details.hz-dd[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (openOverlay) close(openOverlay);
        $$('details.hz-dd[open]').forEach(function (d) { d.removeAttribute('open'); });
      }
    });
    window.addEventListener('resize', function () {
      var d = $('[data-drawer]');
      if (window.innerWidth >= 1024 && d && d.classList.contains('is-open')) close(d);
    });
  }

  /* ---------- cart (AJAX) ---------- */
  function refreshCart(openAfter) {
    return fetch((cfg.routes.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var cur = $('[data-cart-inner]');
        if (fresh && cur) cur.replaceWith(fresh);
        var count = fresh ? parseInt(fresh.getAttribute('data-count'), 10) || 0 : 0;
        $$('[data-cart-count]').forEach(function (b) { b.textContent = count > 999 ? '999+' : count; b.hidden = count === 0; });
        if (openAfter) open($('[data-cart-drawer]'));
      });
  }

  function addToCart(items) {
    return fetch(cfg.routes.cartAdd || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || cfg.strings.error); return j; });
    });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      e.preventDefault();
      var drawer = $('[data-cart-drawer]');
      if (drawer) drawer.classList.add('is-busy');
      fetch(cfg.routes.cartChange || '/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.getAttribute('data-cart-change'), quantity: Math.max(0, parseInt(btn.getAttribute('data-qty'), 10) || 0) })
      }).then(function (r) { if (!r.ok) throw new Error(); return refreshCart(false); })
        .catch(function () { toast(cfg.strings.error, true); })
        .then(function () { if (drawer) drawer.classList.remove('is-busy'); });
    });

    // quick add buttons on product cards
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-add-form]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }])
        .then(function () { return refreshCart(true); })
        .catch(function (err) { toast(err.message, true); });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var price = Number(root.getAttribute('data-price')) || 0;
    var compare = Number(root.getAttribute('data-compare')) || 0;
    var qty = 1;
    var bundles = $$('[data-bundle]', root);
    var tiers = bundles.map(function (b) { return { el: b, qty: Number(b.getAttribute('data-qty')) || 1, pct: Number(b.getAttribute('data-pct')) || 0 }; })
      .sort(function (a, b) { return a.qty - b.qty; });

    function tierFor(q) {
      var t = null;
      tiers.forEach(function (x) { if (q >= x.qty) t = x; });
      return t || { pct: 0 };
    }
    function unitFor(q) { return Math.round(price * (100 - tierFor(q).pct) / 100); }

    function render() {
      var unit = unitFor(qty);
      var total = unit * qty;
      var full = price * qty;
      var saving = full - total;
      if (compare > price) saving = compare * qty - total;
      if (qtyInput) qtyInput.value = qty;
      $$('[data-qty-value]', root).forEach(function (el) { el.textContent = qty; });
      $$('[data-qty-minus]', root).forEach(function (el) { el.disabled = qty <= 1; });
      var active = tierFor(qty);
      tiers.forEach(function (x) {
        x.el.classList.toggle('is-active', x === active);
        var p = x.el.querySelector('[data-bundle-price]');
        if (p) p.textContent = formatMoney(Math.round(price * (100 - x.pct) / 100));
        var w = x.el.querySelector('[data-bundle-was]');
        var unitHere = Math.round(price * (100 - x.pct) / 100);
        var wasVal = compare > unitHere ? compare : (x.pct > 0 ? price : 0);
        if (w) { w.hidden = !wasVal; w.textContent = formatMoney(wasVal); }
      });
      $$('[data-sum-qty],[data-sticky-qty]', root).forEach(function (el) { el.textContent = qty; });
      $$('[data-sum-subtotal]', root).forEach(function (el) { el.textContent = formatMoney(total); });
      $$('[data-sum-total],[data-sticky-total]', root).forEach(function (el) { el.textContent = formatMoney(total); });
      $$('[data-sum-saving-row]', root).forEach(function (el) { el.hidden = saving <= 0; });
      $$('[data-sum-saving]', root).forEach(function (el) { el.textContent = '-' + formatMoney(saving); });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bundle]');
      if (b) { qty = Number(b.getAttribute('data-qty')) || 1; render(); return; }
      if (e.target.closest('[data-qty-minus]')) { qty = Math.max(1, qty - 1); render(); return; }
      if (e.target.closest('[data-qty-plus]')) { qty = Math.min(999, qty + 1); render(); return; }
    });

    var select = $('[data-variant-select]', root);
    if (select) {
      select.addEventListener('change', function () {
        var o = select.options[select.selectedIndex];
        idInput.value = o.value;
        price = Number(o.getAttribute('data-price')) || price;
        compare = Number(o.getAttribute('data-compare')) || 0;
        var avail = o.getAttribute('data-available') === 'true';
        $$('[data-add-btn],[data-buy-now]', root).forEach(function (b) { b.disabled = !avail; });
        var now = $('[data-price-now]', root); if (now) now.textContent = formatMoney(price);
        var was = $('[data-price-was]', root); if (was) { was.hidden = !(compare > price); was.textContent = formatMoney(compare); }
        var m = parseInt(o.getAttribute('data-media'), 10);
        if (m >= 0 && root._goTo) root._goTo(m);
        var url = new URL(window.location.href); url.searchParams.set('variant', o.value);
        history.replaceState(null, '', url.toString());
        render();
      });
    }

    function setStep(n) {
      var p = $('[data-progress]', root); if (!p) return;
      $$('.hz-progress__step', p).forEach(function (s) {
        var k = Number(s.getAttribute('data-step-n'));
        s.classList.toggle('is-done', k < n); s.classList.toggle('is-current', k === n);
      });
      $$('.hz-progress__bar', p).forEach(function (bar, i) { bar.classList.toggle('is-done', i + 1 < n); });
    }

    function submit(buyNow, btn) {
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.classList.add('is-loading'); if (buyNow) btn.textContent = cfg.strings.processing || '...'; }
      if (buyNow) setStep(2);
      addToCart([{ id: Number(idInput.value), quantity: qty }])
        .then(function () {
          if (buyNow) { setStep(3); window.location.href = '/checkout'; return; }
          return refreshCart(true);
        })
        .catch(function (err) { toast(err.message || cfg.strings.error, true); setStep(1); })
        .then(function () { if (btn && !buyNow) { btn.classList.remove('is-loading'); btn.innerHTML = label; } });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false, $('[data-add-btn]', root)); });
    $$('[data-add-btn]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); submit(false, b); }); });
    $$('[data-buy-now]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); submit(true, b); }); });

    // focus on the details column moves the progress bar to step 2, like the Lovable page
    var summary = $('[data-summary]', root);
    if (summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) setStep(2); }); }, { threshold: 0.6 }).observe(summary);
    }

    initGallery(root);
    render();
  }

  function initGallery(root) {
    var g = $('[data-gallery]', root); if (!g) return;
    var track = $('[data-gallery-track]', g);
    var slides = $$('[data-gallery-slide]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    if (!track || !slides.length) return;
    var idx = 0;
    function goTo(i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
      mark();
    }
    function mark() { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); }); }
    root._goTo = goTo;
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-gallery-thumb'))); }); });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { idx = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); mark(); }, 80);
    }, { passive: true });
    if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
  }

  /* ---------- reviews "load more" ---------- */
  function initReviews() {
    $$('[data-reviews]').forEach(function (sec) {
      var btn = $('[data-reviews-more]', sec); if (!btn) return;
      var step = parseInt(sec.getAttribute('data-step'), 10) || 3;
      btn.addEventListener('click', function () {
        var hidden = $$('[data-review].is-hidden', sec);
        hidden.slice(0, step).forEach(function (r) { r.classList.remove('is-hidden'); });
        if (hidden.length <= step) btn.parentNode.hidden = true;
      });
    });
  }

  /* ---------- back to top ---------- */
  function initTop() {
    var b = $('[data-back-to-top]'); if (!b) return;
    var on = function () { b.classList.toggle('is-visible', window.scrollY > 300); };
    window.addEventListener('scroll', on, { passive: true }); on();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- videos: make sure muted loops really autoplay ---------- */
  function initVideos() {
    $$('.hz-loopvideo video, .hz-gallery__slide video[autoplay]').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function init() {
    initHeader(); initAnnouncements(); initDrawers(); initCart(); initReviews(); initTop(); initVideos();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // theme editor: re-run when a section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    initHeader(); initAnnouncements(); initReviews(); initVideos();
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest('[data-drawer]'); if (d) open(d);
  });
})();
